export enum ErrorType {
  AlreadyPurchased = "AlreadyPurchased",
  NoMetadataForBook = "NoMetadataForBook",
  BookIdNotFound = "BookIdNotFound",
  TransactionIdNotFound = "TransactionIdNotFound",
  LovdataUserIdNotFound = "LovdataUserIdNotFound",
  LovdataUserIdNotActive = "LovdataUserIdNotActive",
  BFFAPICallError = "BFFAPICallError",
  LovdataAPICallError = "LovdataAPICallError",
  NotGettingRedirectUrlFromVipps = "NotGettingRedirectUrlFromVipps",
  VippsAPICallError = "VippsAPICallError",
  UnknownError = "UnknownError",
}
